import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ThemeCtx = createContext({ dark: false, toggle: () => {} });

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem("teslam_dark") === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
    localStorage.setItem("teslam_dark", dark ? "1" : "0");
  }, [dark]);

  const toggle = useCallback(async () => {
    setDark((d) => {
      const next = !d;
      api.patch("/auth/me", { dark_mode: next }).catch(() => {});
      return next;
    });
  }, []);

  return <ThemeCtx.Provider value={{ dark, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
